import { ToastContainer } from './notifications';
import { useToast } from '@/hooks/useToast';

export function ToastProvider() {
  const { toasts, remove } = useToast();
  return <ToastContainer toasts={toasts} onRemove={remove} />;
}


